export default __webpack_public_path__ + "static/media/visa.308210d2.webp";